import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class EventBusService {
	private subject$ = new Subject<EventData>();

	emit(event: EventData) {
		this.subject$.next(event);
	}

	on(eventName: string, action: any): Subscription {
		return this.subject$
			.pipe(filter((e: EventData) => e.name === eventName))
			.subscribe(action);
	}
}

export class EventData {
	name: string;
	constructor(name: string) {
		this.name = name;
	}
}

export class OptimEventData extends EventData {
	isOptimInProgress: any;
	weekNumber: number;

	constructor(name: string, isOptimInProgress: any, weekNumber: number) {
		super(name);
		this.isOptimInProgress = isOptimInProgress;
		this.weekNumber = weekNumber;
	}
}

export class RefreshEventData extends EventData {
	message: string;

	constructor(name: string) {
		super(name);
	}
}
